import * as Yup from "yup";
import { regexList } from "../../Constants";
import { localNumber } from "../../helper/Format";

export const CurrentAccountDetailsConstants = {
  labels: {
    accountNumber: "Account Number",
    bankName: "Bank Name",
    ifscCode: "IFSC Code"
  },
  placeholders: {
    accountNumber: "enter account number",
    ifscCode: "enter ifsc code",
    bankName: "enter bank name"
  },
  modal: {
    title: "Success information",
    content: "You have successfully submitted your account details"
  },
  feedback: {
    accountVerification:
      "Please provide your current account details for verification",
    loanAcceptance:
      "Congrats,  you have accepted the eligibility loan amount of",
    eligibilityAmount: (eligibilityAmount: number | null) =>
      ` Rs ${localNumber(eligibilityAmount)}`
  },
  buttons: {
    submit: "Submit",
    ok: "Ok"
  }
};

const errorMessages = {
  required: "Required",
  invalidFormat: "Invalid Format"
};

export const CurrentAccountDetailsValidationSchema = Yup.object().shape({
  accountNumber: Yup.string()
    .required(errorMessages.required)
    .matches(regexList.accountNumber, errorMessages.invalidFormat),
  ifscCode: Yup.string()
    .required(errorMessages.required)
    .matches(regexList.ifscCode, errorMessages.invalidFormat),
  bankName: Yup.string()
    .required(errorMessages.required)
    .matches(regexList.minimum1Character, errorMessages.invalidFormat)
});
